import sidebar from '@/config/sidebars/service_titan'
import createVueApp from '@/common/create_app'

Styxie.Initializers.ServiceTitanLinking = {
  index: async(props) => {
    const { default: LinkingIndex } = await import('@/vue_widgets/service_titan/linking/index.vue')
    createVueApp(LinkingIndex, { props, sidebar })
  }
}
